import lodash from "lodash";
import store from "../../store";
import { createButtonCreate } from "../../utils/button";
import { conditionFormChecker, onClickDeleteAllClient } from "../../utils/form";
import { createLoading } from "../../utils/loading";
import { createManageDelete, createManageExportCsv, createPage } from "../../utils/page";
import { createColumnInlineCheckbox, createColumnInlineInput } from "../table/c-table.logic";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/declaration";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];
    columns.push(
        createColumnInlineCheckbox({
            dataIndex: "isCheck",
            items,
            useForm,
            itemsKey,
            customRenderInputProp: ({ key }) =>
                lodash.merge({ disabled: viewOnly }, conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })),
            sorter: false
        })
    );
    columns.push(
        createColumnInlineInput({
            dataIndex: "name",
            items,
            useForm,
            itemsKey,
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    { disabled: viewOnly || record.refDeclaration },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                ),
            width: 400,
            sorter: false
        })
    );
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, canCreate, canDelete } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : canDelete),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            },
            getCheckboxProps: ({ record }) => ({ disabled: record.refDeclaration })
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [
        {
            render: () => createButtonCreate({ onClick: () => items.push({ isCheck: true }) }),
            visible: () => (viewOnly ? false : canCreate)
        }
    ];
    data.rowActions = [];
    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
